"use strict";

$(function(){

    $('.prevent').on('click', function(event) {
        event.preventDefault();

        let target = $(this).attr('href');
        scrollTo(target, 62, 100);

    });

    $('.nav-link').on('click', function(event) {
        event.preventDefault();

        let target = $(this).attr('href');
        scrollTo(target, 62, 100);

        if ($('#navbarLinks').hasClass('show')) {
            $('button.navbar-toggler').click();
        }
    });

    $('a.navbar-brand').on('click', function(event) {
        event.preventDefault();

        if ($('#navbarLinks').hasClass('show')) {
            $('button.navbar-toggler').click();
        }

        $('.nav-link').removeClass('active');

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    // Cookie
    let cookie = $('#cookie');
    if (!getCookie('accept-cookie')) {
        cookie.toast('show');
    } else {
        cookie.hide();
    }
    $('#btn-cookie').on('click', function() {
        setCookie('accept-cookie', 1, 30);
    });


    // OSM
    let map = L.map('map-osm').setView([54.75529, 17.55489], 15);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    }).addTo(map);

    let myIcon = L.icon({
        iconUrl: '../styles/images/marker-icon.webp',
        shadowUrl: '../styles/images/marker-shadow.webp',
        iconSize:     [34, 51],
        shadowSize:   [50, 64],
        iconAnchor:   [4, 48],
        shadowAnchor: [4, 62]
    });

    L.marker([54.75529, 17.55489], {icon: myIcon}).addTo(map);
    map.scrollWheelZoom.disable();

    // Gallery
    const myCarousel = $('#gallery-carousel');

    $('.gallery-item').on('click', function() {
        const that = $(this);
        const thatRel = that.attr('rel');

        $('#gallery-modal').on('show.bs.modal', function () {
            myCarousel.find('.carousel-item').remove();

            $('.gallery-item[rel='+thatRel+']').each(function() {
                const src = $(this).attr('src');
                const carouselInner = myCarousel.find('.carousel-inner');


                if ( $(this).is(that) ) {
                    carouselInner.append('' +
                        '<div class="carousel-item active">' +
                            '<div class="img-wrap w-100">' +
                                '<img src="'+src+'" class="d-block carousel-img "/>' +
                            '</div>' +
                        '</div>')
                } else {
                    carouselInner.append('' +
                        '<div class="carousel-item">' +
                            '<div class="img-wrap">' +
                                '<img src="'+src+'" class="d-block carousel-img "/>' +
                            '</div>' +
                        '</div>')
                }
            });
        });

        $('#gallery-modal').on('shown.bs.modal', function () {
        });

        const myModal = new bootstrap.Modal($('#gallery-modal'));
        myModal.show();
    });


    myCarousel.on('slide.bs.carousel', function () {

    });
});

function setCookie(name, value, days) {
    let expires;

    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function getCookie(name) {
    let nameEQ = encodeURIComponent(name) + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    setCookie(name, "", -1);
}

function scrollTo(el, offset, duration) {
    $('html, body').animate({
        scrollTop: $(el).offset().top - offset
    }, duration);
}
